        <template>
  <div
      >
    <b-row
          >
                                    <b-col
                                                                                                >
                            <e-commerce-product-details />            </b-col>
                            </b-row>
  </div>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BRow,
  BCol,
} from 'bootstrap-vue'


                                      import ECommerceProductDetails from '@core/components/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'
                            
export default {
  components: {
    BRow,
    BCol,

                                                          ECommerceProductDetails,
                                          },
  setup() {
    
      },
}
</script>
    